import { NgModule, ModuleWithProviders } from '@angular/core';
import { provideSkyproBaseConfig } from './helpers';

@NgModule()
export class SkyproBaseConfigModule {
  static forRoot(rootDomain: string): ModuleWithProviders<SkyproBaseConfigModule> {
    return {
      ngModule: SkyproBaseConfigModule,
      providers: [provideSkyproBaseConfig(rootDomain)],
    };
  }
}
